import React, { Component } from 'react';
import { MessageCircle } from 'lucide-react';
export function SignupForm() {
  const whatsappMessage = encodeURIComponent(`Hi, I want to get Beta access of Welma.

My name is: ___
I'm a: ___ (profession)
I have approximately ___ active clients
My email is: ___`);
  const whatsappLink = `https://wa.me/7984554668?text=${whatsappMessage}`;
  return <section id="signup-form" className="py-20 px-6 max-w-2xl mx-auto text-center" data-id="element-81">
      <div className="bg-white p-8 md:p-12 rounded-3xl shadow-lg shadow-[#A39B8B]/10 border border-[#FAFAF8]" data-id="element-82">
        <div className="mb-8" data-id="element-83">
          <h2 className="text-3xl font-bold text-[#2D2D2D] mb-4" data-id="element-84">
            Ready to join?
          </h2>
          <p className="text-lg text-[#2D2D2D]/70" data-id="element-85">
            Send us a quick WhatsApp message and we'll reach out personally
            before onboarding.
          </p>
        </div>

        <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-10 py-5 text-xl font-medium text-white bg-[#25D366] rounded-full hover:bg-[#20BD5A] transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105" data-id="element-86">
          <MessageCircle className="w-6 h-6 mr-3" data-id="element-87" />
          Request Beta Access
        </a>

        <p className="mt-6 text-sm text-[#2D2D2D]/50" data-id="element-88">
          Opens WhatsApp with a pre-filled message
        </p>
      </div>
    </section>;
}